import styled from 'styled-components';

export default styled.div`
  position: relative;
  margin: 0 10px 10px;
  padding: 5px 0;
`;
